(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collection-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  const link = e.target.closest('.rs-col-card');
  if(!link) return;

  // create ripple
  const rect = link.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const ripple = document.createElement('span');
  ripple.className = 'rs-ripple';
  ripple.style.width = ripple.style.height = size + 'px';
  ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
  ripple.style.top  = (e.clientY - rect.top  - size/2) + 'px';
  link.appendChild(ripple);
  setTimeout(()=> ripple.remove(), 520);

  // small delay so the ripple is visible, then navigate
  e.preventDefault();
  setTimeout(()=>{ window.location.href = link.href; }, 160);
}, {capture:true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collections-card"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e){
  const link = e.target.closest('.rs-col-card');
  if(!link) return;

  // create ripple
  const rect = link.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const ripple = document.createElement('span');
  ripple.className = 'rs-ripple';
  ripple.style.width = ripple.style.height = size + 'px';
  ripple.style.left = (e.clientX - rect.left - size/2) + 'px';
  ripple.style.top  = (e.clientY - rect.top  - size/2) + 'px';
  link.appendChild(ripple);
  setTimeout(()=> ripple.remove(), 520);

  // small delay so the ripple is visible, then navigate
  e.preventDefault();
  setTimeout(()=>{ window.location.href = link.href; }, 160);
}, {capture:true});

  } catch(e) { console.error(e); }
})();
})();
